import { INBOX_SORT_MODE_LABELS, InboxSortMode } from '@bariendo/lib/inbox-sort';
import { Group, Menu, Text, UnstyledButton } from '@mantine/core';
import { IconChevronDown } from '@tabler/icons-react';
import { ReactElement } from 'react';
import { INBOX_TOOLBAR_CHIP_STYLE } from './chip-style';

const SORT_OPTIONS: InboxSortMode[] = [InboxSortMode.NEWEST_FIRST, InboxSortMode.DUE_DATE];

export interface InboxSortDropdownProps {
  value: InboxSortMode;
  onChange: (mode: InboxSortMode) => void;
}

export function InboxSortDropdown({ value, onChange }: InboxSortDropdownProps): ReactElement {
  return (
    <Menu position="bottom-end" withinPortal>
      <Menu.Target>
        <UnstyledButton aria-label="Sort inbox items" style={INBOX_TOOLBAR_CHIP_STYLE}>
          <Group gap={6} wrap="nowrap">
            <Text size="sm" c="dimmed">
              Sort ·
            </Text>
            <Text size="sm">{INBOX_SORT_MODE_LABELS[value]}</Text>
            <IconChevronDown size={14} stroke={1.5} />
          </Group>
        </UnstyledButton>
      </Menu.Target>
      <Menu.Dropdown>
        {SORT_OPTIONS.map((mode) => (
          <Menu.Item key={mode} onClick={() => onChange(mode)} fw={mode === value ? 600 : 400}>
            {INBOX_SORT_MODE_LABELS[mode]}
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  );
}
